// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Overlay Component */
:host {
  display: block;
  pointer-events: none;
}

:host([background-color=page]) {
  z-index: -1;
}

.ids-overlay {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  display: none;
  outline: 0;
  position: fixed;
  pointer-events: none;
  background-color: rgb(var(--ids-overlay-background-color)/0);
  transition: background-color 0.2s;
}
.ids-overlay.visible {
  display: block;
  background-color: rgb(var(--ids-overlay-background-color)/0.3);
  pointer-events: auto;
}

:host(.contained)::part(overlay) {
  position: relative;
}

[slot=widget-content], [slot=card-content] {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-modal/ids-overlay.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA;EACE,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EAGA,4DAAA;EACA,iCAAA;AADF;AAGE;EACE,cAAA;EACA,8DAAA;EACA,oBAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAFF","sourcesContent":["/* Ids Overlay Component */\n:host {\n  display: block;\n  pointer-events: none;\n}\n\n:host([background-color=\"page\"]) {\n  z-index: -1;\n}\n\n.ids-overlay {\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  box-sizing: border-box;\n  display: none;\n  outline: 0;\n  position: fixed;\n  pointer-events: none;\n\n  // Animation\n  background-color: rgb(var(--ids-overlay-background-color) / 0);\n  transition: background-color 0.2s;\n\n  &.visible {\n    display: block;\n    background-color: rgb(var(--ids-overlay-background-color) / 0.3);\n    pointer-events: auto;\n  }\n}\n\n:host(.contained)::part(overlay) {\n  position: relative;\n}\n\n[slot=\"widget-content\"],[slot=\"card-content\"] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-height: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
